import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            编辑精选的影视资讯，不错过每一部好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, idx) => {
            const images = [
              'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20lantern%20light%20and%20intricate%20wood%20carvings%2C%20cinematic%20drama%20scene%2C%20mysterious%20atmosphere%2C%20historical%20aesthetic%2C%20rich%20amber%20tones%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=card-img-01&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Modern%20urban%20street%20at%20dusk%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20solitary%20figure%2C%20realistic%20drama%20film%20aesthetic%2C%20moody%20cinematography%2C%20warm%20orange%20and%20teal%20color%20grading&width=800&height=500&seq=card-img-02&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Korean%20traditional%20hanok%20village%20with%20morning%20mist%20and%20soft%20golden%20sunlight%2C%20serene%20atmosphere%2C%20period%20drama%20visual%20style%2C%20gentle%20warm%20tones%2C%20cinematic%20composition&width=800&height=500&seq=card-img-03&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20corridor%20with%20blue%20ambient%20lighting%20and%20holographic%20displays%2C%20sci-fi%20film%20aesthetic%2C%20sleek%20metallic%20surfaces%2C%20atmospheric%20fog%2C%20wide%20cinematic%20shot&width=800&height=500&seq=card-img-04&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20garden%20with%20blooming%20plum%20blossoms%20and%20moonlight%2C%20poetic%20martial%20arts%20film%20atmosphere%2C%20silver%20moonlight%20through%20branches%2C%20ethereal%20warm%20glow&width=800&height=500&seq=card-img-05&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Epic%20mythological%20silhouette%20against%20golden%20sunset%20sky%20with%20swirling%20clouds%2C%20dramatic%20backlighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20wide%20shot%2C%20fantasy%20film%20aesthetic&width=800&height=500&seq=card-img-06&orientation=landscape',
            ];
            return (
              <article
                key={item.id}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={images[idx]}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-accent-500 text-white">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                    <i className="ri-calendar-line"></i>
                    <span>{item.date}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}